export const SET_VEHICLE_INFO = 'SET_VEHICLE_INFO';
export const SET_ITEMS = 'SET_ITEMS';
export const SET_DEALER_CODE = 'SET_DEALER_CODE';



// WEBPACK FOOTER //
// ./src/actions/types.js